export default __webpack_public_path__ + "static/media/subsection-how-we-work.010bd174.svg";